import React, { useState, useEffect, useRef, useCallback } from "react";
import { FileText, Video } from "lucide-react";

export default function ResourceMentionDropdown({ items, onSelect, onDismiss, position }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const listRef = useRef(null);

    useEffect(() => { setActiveIndex(0); }, [items]);

    const handleKeyDown = useCallback((e) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveIndex((i) => Math.min(i + 1, items.length - 1));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveIndex((i) => Math.max(i - 1, 0));
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (items[activeIndex]) onSelect(items[activeIndex]);
        } else if (e.key === "Escape") {
            e.preventDefault();
            onDismiss();
        }
    }, [items, activeIndex, onSelect, onDismiss]);

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [handleKeyDown]);

    useEffect(() => {
        const active = listRef.current?.children[activeIndex];
        if (active) active.scrollIntoView({ block: "nearest" });
    }, [activeIndex]);

    if (!items.length) return null;

    return (
        <>
            <div className="fixed inset-0 z-40" onClick={onDismiss} />
            <div ref={listRef} style={position ? { top: `${position.top}px`, left: `${position.left}px` } : { bottom: "100%", left: 0 }}
                className="absolute z-50 w-72 max-h-60 overflow-y-auto bg-popover border rounded-lg shadow-lg py-1">
                {items.map((item, i) => (
                    <button key={item.id} onClick={() => onSelect(item)}
                        className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-accent transition-colors ${i === activeIndex ? "bg-accent" : ""}`}>
                        {item.type === "doc" ? <FileText className="w-4 h-4 text-blue-500 flex-shrink-0" /> : <Video className="w-4 h-4 text-red-500 flex-shrink-0" />}
                        <span className="truncate">{item.title}</span>
                    </button>
                ))}
            </div>
        </>
    );
}
